import { render, staticRenderFns } from "./Ganuge.vue?vue&type=template&id=2457b6b6&scoped=true"
import script from "./Ganuge.vue?vue&type=script&lang=js"
export * from "./Ganuge.vue?vue&type=script&lang=js"
import style0 from "./Ganuge.vue?vue&type=style&index=0&id=2457b6b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2457b6b6",
  null
  
)

export default component.exports